import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./utils.js";
const tones = {
    attention: "border-amber-200 bg-amber-50 text-amber-900",
    danger: "border-red-200 bg-red-50 text-red-900",
    info: "border-stone-200 bg-stone-50 text-stone-900",
    positive: "border-emerald-200 bg-emerald-50 text-emerald-900",
};
export function Banner({ action, children, className, title, tone, }) {
    return (_jsxs("div", { className: cn("flex flex-wrap items-center justify-between gap-x-4 gap-y-3 rounded-xl border p-4", tones[tone], className), role: tone === "danger" ? "alert" : "status", children: [_jsxs("div", { className: "min-w-0", children: [_jsx("p", { className: "text-sm font-semibold", children: title }), children ? _jsx("div", { className: "mt-1 text-sm", children: children }) : null] }), action ? _jsx("div", { className: "shrink-0", children: action }) : null] }));
}
